import { ExtractPropTypes, PropType } from "vue";
import type { UiTypes } from "@various/constants";

export const UiModalSidePropsOption = {
    close: { type: Boolean, default: true }, //? 模态框是否显示关闭按钮
    width: { type: [String, Number] as PropType<string | number> },
    height: { type: [String, Number] as PropType<string | number> },
    zIndex: { type: Number, default: 666 },
    spacing: { type: String, default: "0 56px 56px" }, //? 内间距
    maxWidth: { type: [String, Number] as PropType<string | number> },
    minWidth: { type: [String, Number] as PropType<string | number> },
    minHeight: { type: [String, Number] as PropType<string | number> },
    maxHeight: { type: [String, Number] as PropType<string | number> },
    direction: { type: String as PropType<UiTypes.direction>, default: "right" },
    closeSize: { type: Number, default: 48 },
    closeIcon: { type: String, default: "close" },
    classExtraName: { type: String }, //? 模态框class名称,
};

export type UiModalSideProps = ExtractPropTypes<typeof UiModalSidePropsOption>;

export const UiModalSideEmits = {
    open: () => true,
    close: () => true,
};
